// Style dokumentu (podgląd, pomiar, wydruk) i reguły wydruku — globalne, wstawiane tylko na stronach dokumentów.
// Klasy z templates.js są ogólne (b, v, lines), dlatego każda reguła jest pod .spl-doc.
// Krój z rodziny Times: Liberation Serif, Nimbus Roman i Tinos mają metryki zgodne z Times New Roman,
// więc dopasowanie do A4 liczone w przeglądarce jest takie samo na Windows, macOS i Linux.
const DOC_CSS = `
.spl-doc{font-family:"Times New Roman",Times,"Liberation Serif","Nimbus Roman","Nimbus Roman No9 L",Tinos,serif;font-size:var(--fs,10.5pt);line-height:1.32;color:#000;background:#fff;display:flex;flex-direction:column;min-height:267mm;overflow-wrap:anywhere;font-kerning:normal;text-rendering:optimizeLegibility;text-align:left;letter-spacing:normal}
.spl-doc *{color:#000;font-family:inherit;letter-spacing:inherit}
/* reguły serwisu (.main h2, base.css: kolor nagłówków i pogrubień) mają wyższą specyficzność niż .spl-doc * */
.spl-doc.spl-doc :is(h2,h3,p,li,b,strong,span,s,div){font-family:inherit;font-stretch:normal;color:#000}
.spl-doc p{margin:0 0 .42em;font-size:1em;line-height:inherit}
.spl-doc b,.spl-doc strong{font-weight:700}
.spl-doc .d-title{font-size:1.4em;line-height:1.2;font-weight:700;font-stretch:normal;text-align:center;text-transform:uppercase;letter-spacing:.05em;margin:0 0 1em}
.spl-doc .d-par{text-align:center;font-weight:700;margin:.6em 0 .15em}
.spl-doc h3{font-size:1em;font-weight:700;font-stretch:normal;letter-spacing:.03em;margin:.7em 0 .25em;line-height:1.3}
.spl-doc .d-who{margin:.2em 0 0}
.spl-doc .d-parties .b{min-width:min(var(--w,32mm),100%)}
.spl-doc .d-who p{margin-bottom:.22em}
.spl-doc .d-cols{display:grid;grid-template-columns:1fr 1fr;gap:0 7mm;margin-top:.2em}
.spl-doc .d-cols h3{margin-top:.2em}
.spl-doc .d-ol{margin:0 0 .42em;padding-left:1.4em;list-style:decimal}
.spl-doc .d-ol li{margin-bottom:.18em}
.spl-doc .b{display:inline-block;min-width:var(--w,32mm);max-width:100%;height:1.05em;border-bottom:.6pt solid #000;vertical-align:-.28em;position:relative}
.spl-doc .b[data-h]::after{content:attr(data-h);position:absolute;left:0;right:0;top:calc(100% + 1px);font-size:6.5pt;line-height:1.1;text-align:center;font-style:italic;white-space:nowrap}
.spl-doc .has-h{line-height:2.1}
.spl-doc .lines{display:block}
.spl-doc .lines>span{display:block;height:1.7em;border-bottom:.6pt solid #000}
.spl-doc .d-sketch{margin:.5em 0 .3em}
.spl-doc .d-sketch-box{position:relative;height:50mm;border:.75pt solid #000}
.spl-doc .d-sketch-box span{position:absolute;top:1.5mm;left:2mm;font-size:.85em;font-weight:700}
.spl-doc .d-cap{margin-top:.25em;font-size:.85em;text-align:center;font-style:italic}
.spl-doc .d-right{text-align:right}
.spl-doc .d-owners{margin:1.2em 0 .6em}
.spl-doc .d-c{text-align:center}
.spl-doc .d-capt{display:flex;flex-direction:column;margin-bottom:.5em}
.spl-doc .d-capt .b.d-full{display:block;min-width:0;width:100%;height:1.6em}
.spl-doc .d-hint{font-size:.75em;font-style:italic;text-align:center}
.spl-doc .d-office{margin:.6em 0 .4em}
.spl-doc .d-att{display:flex;align-items:baseline;gap:.5em}
.spl-doc .d-box{flex:none;display:inline-block;width:.9em;height:.9em;border:.6pt solid #000;line-height:.85em;text-align:center;font-size:1em;vertical-align:-.1em}
.spl-doc .d-decl{margin-top:.8em}
.spl-doc .d-sign{display:grid;grid-template-columns:1fr 1fr;gap:14mm;padding-top:9mm;margin-bottom:6mm;break-inside:avoid}
.spl-doc .d-sign-one{grid-template-columns:1fr 1fr}
.spl-doc .d-sign-one>div{grid-column:2}
.spl-doc .d-sign>div{text-align:center;font-size:.85em}
.spl-doc .d-sign .line{display:block;height:9mm;border-bottom:.6pt dotted #000;margin-bottom:1.2mm}
.spl-doc .d-foot{display:flex;justify-content:space-between;gap:4mm;margin-top:auto;padding-top:1.2mm;border-top:.4pt solid #000;font-size:7pt;line-height:1.2}
.spl-doc .hl{background:#FFF2D5;box-shadow:0 0 0 1.5pt var(--promo)}
#splDocMeasure{position:absolute;left:-10000px;top:0;width:180mm;visibility:hidden;pointer-events:none}
#splDocMeasure .spl-doc{min-height:0}
#printArea{display:none}
@page{size:A4;margin:15mm}
@media print{
  html,body{background:#fff!important;margin:0!important;padding:0!important;min-width:0!important}
  body>*:not(#printArea){display:none!important}
  #printArea{display:block}
  #printArea .copy{break-after:page}
  #printArea .copy:last-child{break-after:auto}
  #printArea .spl-doc{min-height:266mm}
  #printArea .spl-doc *{color:#000!important;background:transparent!important;box-shadow:none!important}
}
`

export default function DocCss () {
    return <style dangerouslySetInnerHTML={{ __html: DOC_CSS }} />
}
